import * as ko from 'knockout';
import entityBase from 'entityBase';

export class request_contact extends entityBase {
    contact_sequence: KnockoutObservable<number>;
    email_address   : KnockoutObservable<string>;
    first_name      : KnockoutObservable<string>;
    last_name       : KnockoutObservable<string>;
    phone           : KnockoutObservable<string>;
    request_id      : KnockoutObservable<string>;
    role_type       : KnockoutObservable<string>;
    sequence        : KnockoutObservable<number>;

    constructor(item: any){
        super();
        this.contact_sequence = ko.observable(item.contact_sequence);
        this.email_address    = ko.observable(item.email_address).extend({ maxLength: 128 });
        this.first_name       = ko.observable(item.first_name).extend({ maxLength: 64 });
        this.last_name        = ko.observable(item.last_name).extend({ maxLength: 64 });
        this.phone            = ko.observable(item.phone).extend({ maxLength: 32 });
        this.request_id       = ko.observable(item.request_id).extend({ maxLength: 32 });
        this.role_type        = ko.observable(item.role_type).extend({ maxLength: 128 });
        this.sequence         = ko.observable(item.sequence);
    }
}


